import React from "react"
import "./Component.css"

export default function Tags(props){
    var cn = props.isChosen? "tag tags-c-" + props.color : "tag tags-" + props.color
    return(
        <div className={cn} onClick={props.onClick}>
            {props.text}
        </div>
    )
}